import o from "./constant.js";
import t from "./_defineProperty.js";
import n from "./identity.js";
var i = t ? function(e, r) {
  return t(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: o(r),
    writable: !0
  });
} : n;
const m = i;
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseSetToString.js
// module id = 1491
// module chunks = 67